<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab lazy>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Genel Bilgiler
        </template>
        <service-card />
      </b-tab>
      <b-tab
        lazy
        :disabled="!dataItem.id"
      >
        <template #title>
          <feather-icon icon="DollarSignIcon" />
          Fiyatlandırma
        </template>
        <prices-card />
      </b-tab>
      <b-tab
        lazy
        :disabled="!dataItem.id"
      >
        <template #title>
          <feather-icon icon="FolderIcon" />
          Dokümanlar
        </template>
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <documents-card />
          </b-col>
          <b-col
            v-if="userData.secret_files === '1' && controlSecretFiles"
            cols="12"
            md="12"
          >
            <secret-documents-card />
          </b-col>
        </b-row>
      </b-tab>
      <b-tab
        :disabled="!dataItem.id"
        lazy
      >
        <template #title>
          <feather-icon icon="FolderIcon" />
          Medya Galeri
        </template>
        <media-card is-view />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  BCol, BRow, BTab, BTabs,
} from 'bootstrap-vue'
import ServiceCard from '@/views/Services/view/ServiceCard.vue'
import DocumentsCard from '@/views/Services/view/DocumentsCard.vue'
import SecretDocumentsCard from '@/views/Services/view/SecretDocumentsCard.vue'
import PricesCard from '@/views/Services/view/PricesCard.vue'
import MediaCard from '@/views/Services/Components/MediaCard.vue'

export default {
  name: 'ServiceView',
  components: {
    MediaCard,
    BTabs,
    BTab,
    BRow,
    BCol,
    ServiceCard,
    PricesCard,
    DocumentsCard,
    SecretDocumentsCard,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
    controlSecretFiles() {
      // userData içindeki packageLimits array'inde subject'i SERVICE_SECRET_FILES olan elemanın limit'i 1 ise true, değilse false döndürür
      if (
        this.userData
          && Array.isArray(this.userData.packageLimits)
      ) {
        const found = this.userData.packageLimits.find(
          item => item.subject === 'SERVICES_SECRET_FILES',
        )
        return found && found.limit === 1
      }
      return false
    },
  },
}
</script>
